var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.99997C9.00039 8.66292 8.73745 9.29887 8.269 9.76797L2.975 15.061L0.854004 12.939L5.793 7.99997L0.854004 3.06098L2.975 0.938973L8.268 6.23197C8.50014 6.46417 8.68426 6.73981 8.80985 7.04317C8.93545 7.34652 9.00006 7.67165 9 7.99997Z",
    fill: "#D69B29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightOrange);
export default __webpack_public_path__ + "static/media/arrowRightOrange.04eb437c4375f4276f87b71cf28cf8f3.svg";
export { ForwardRef as ReactComponent };